// This is a function because we want new state every test.
// If we don't do this, the state is being mutated leading to flaky tests.
export const state = () => ({
  platformDetails: null,
  platformLoadFailed: false,
  invalid: false,
  externalRecord: {},
  externalFiles: {}
});
